// Import necessary functions and modules
import { createApi } from "@reduxjs/toolkit/query/react";
import { apiSliceInterceptor } from "stores/redux/apiSliceInterceptor";


const Order = createApi({
    reducerPath: "Order",
    baseQuery: apiSliceInterceptor.baseQueryWithInterceptor,
    tagTypes: ["GETORDERLIST", "CREATEORDER", "UPDATEORDER"],
  
    endpoints: (qb) => ({
      getOrdersApi: qb.query({
        query: (filters) => {
          const {
            status,
            deliveryDate,
            start_date,
            end_date,
            minimumAmount,
            maximumAmount,
            page,
            limit = 1000,
            noGlobalLoading = true,
            sortOrder = "DESC",
            mode, // 'export' mode
          } = filters || {};
      
          const params = { page, limit, noGlobalLoading, sortOrder };
          if (status) params.status = status;
          if (deliveryDate) params.deliveryDate = deliveryDate;
             if (start_date) params.start_date = start_date;
                  if (end_date) params.end_date = end_date;
          if (minimumAmount) params.minimumAmount = minimumAmount;
          if (maximumAmount) params.maximumAmount = maximumAmount;
          if (mode) params.mode = mode;
      
          const isExport = mode === "export";
      
          return {
            url: `api/order/`,
            method: "GET",
            params,
            responseHandler: isExport ? (res) => res.blob() : undefined, // 🔥 key line!
          };
        },
        transformResponse: (response, meta, arg) => {
          if (arg?.mode === "export") return response; // blob as-is
          return response; // regular JSON
        },
      }),
      
        
  
        createOrdersApi: qb.mutation({
            query: (data) => ({
              url: `api/order/`,
              method: "POST",
              body: {
                userId: data.userId,
                driver:data.driver,
                products: data.products,
                remarks:data.description  

              },
            }),
            invalidatesTags: ["CREATEORDER"],
          }),
          
          updateOrdersApi: qb.mutation({
            query: ({ orderId, driver, orderStatus, deliveryDate,products,remarks }) => ({
              url: `api/order/${orderId}`, // Append orderId to the URL
              method: "PUT",
              body: {
                driver,
                orderStatus,
                deliveryDate,
                products,
                remarks
              },
            }),
            invalidatesTags: ["UPDATEORDER"],
          }),
          
    }),
  });
  
  export const OrdersApiReducer = Order.reducer;
  
  export const ordersApiAction = {
    middleware: Order.middleware,
    reducerPath: Order.reducerPath,
    getOrdersApi: Order.useGetOrdersApiQuery,
    createOrdersApi: Order.useCreateOrdersApiMutation,
    updateOrdersApi: Order.useUpdateOrdersApiMutation,
    endpoints: Order.endpoints,
  };
  
